import { DropdownOption } from '@ip-only/front-end-library';
import {
  CONTRACTOR_USER_ADMIN_ROLES,
  LAND_AGREEMENT_ROLES,
  LAND_SURVEY_ROLES,
  NETWORK_IMPORT_ROLES,
  SPAN_ROLES_VIEW,
  WORK_VARIATION_ROLES,
} from '../user-roles-def/user-roles';

interface DeliveryPortalAppTypes {
  name: string;
  label: string;
  eligableUsers: string[];
}

const applicationsTable: DeliveryPortalAppTypes[] = [
  {
    name: 'users',
    label: 'usersLabel',
    eligableUsers: CONTRACTOR_USER_ADMIN_ROLES,
  },
  {
    name: 'landSurverys',
    label: 'landSurveyLabel',
    eligableUsers: LAND_SURVEY_ROLES,
  },
  {
    name: 'rolloutProgress',
    label: 'rolloutProgressLabel',
    eligableUsers: SPAN_ROLES_VIEW,
  },
  {
    name: 'landAgreements',
    label: 'landAgreementLabel',
    eligableUsers: LAND_AGREEMENT_ROLES,
  },
  {
    name: 'workVariation',
    label: 'workVariationLabel',
    eligableUsers: WORK_VARIATION_ROLES,
  },
  {
    name: 'networkImport',
    label: 'networkImportLabel',
    eligableUsers: NETWORK_IMPORT_ROLES,
  },
];

const emailSubjectOptions: DropdownOption[] = [
  {
    value: 'Bug',
    label: 'emailSubject.bug',
  },
  {
    value: 'System unavailable',
    label: 'emailSubject.systemUnavailable',
  },
  {
    value: 'Feature request',
    label: 'emailSubject.featureRequest',
  },
  {
    value: 'Feedback',
    label: 'emailSubject.feedback',
  },
  {
    value: 'General question',
    label: 'emailSubject.generalQuestion',
  },
  {
    value: 'Others',
    label: 'emailSubject.others',
  },
];

export { applicationsTable, DeliveryPortalAppTypes, emailSubjectOptions };
